/**
 * Copyright Mántum All Rights Reserved.
 */
import { useMemo } from 'react';

type PropTypes = {
    active?: boolean;
    index: number;
    onSelected?: (index: number) => void;
    testid?: string;
    title: string;
};

export default function Row(props: PropTypes) {
    const active = useMemo(() => {
        return props.active
            ? 'border-b-primary text-base font-medium bg-accent'
            : '';
    }, [props.active]);

    const onSelected = () => {
        if (props.onSelected) {
            props.onSelected(props.index);
        }
    };

    return (
        <li role='row' aria-rowindex={props.index}>
            <button
                aria-controls={`tabs-${props.title}`}
                aria-selected={props.active}
                className={`nav-link my-2 max-w-40 truncate block rounded-t-sm border-x-0 border-b-2 border-transparent px-6 py-3 text-base font-normal leading-tight hover:bg-accent ${active}`}
                data-testid={props.testid}
                onClick={onSelected}
                role='tab'
                title={props.title}
            >
                {props.title}
            </button>
        </li>
    );
}
